<template>
	<div
		class="cell">
		<div
			class="grid"
			style="position: relative;">
			<div class="cell">
				<h4 v-text="title"/>
				<p
					class="mb-s"
					v-html="description"/>
				<label class="custom-size-checkbox cursor-pointer">
					<input
						class="input-field input-field--custom"
						type="checkbox"
						:value="checked(option.id)"
						@click="clickHandler"
						v-model="customFormat">
					<span class="input-field__selectable mr-s"/>
					<p>Ik wil verder met een maatwerk formaat</p>
				</label>
			</div>
			<modal
				v-if="type === 'format'"
				title="Informatie & aanleverspecificaties"
				button-style="tooltip"
				button-text="Informatie">
				<delivery-specification :format="option"/>
			</modal>
		</div>
	</div>
</template>

<script>
import modal from "@/components/element/modal";
import deliverySpecification from "@/components/information/delivery-specification";

export default {
	name: "FormatCustomChoice",
	props: {
		"option": {
			type: Object,
			required: true
		},
		"disabled": {
			type: Boolean,
			default: false
		},
		"type": {
			type: String,
			default: null
		},
		"hasSuggestion": {
			type: Boolean,
			default: false
		}
	},
	components: {
		modal,
		deliverySpecification
	},
	data () {
		return {
			customFormat: false
		};
	},
	computed: {
		formatInfo () {
			return this.option.productSize;
		},
		selectedFormat () {
			return this.$store.getters.getSelectedFormat;
		},
		wantsCustomFormat () {
			return this.customFormat;
		},
		uploaderPosition () {
			return this.$store.getters.getUploaderPosition;
		},
		title () {
			return this.hasSuggestion ? "Liever maatwerk?" : "Geen suggesties voor dit formaat. Liever maatwerk?";
		},
		description () {
			return this.hasSuggestion
				? "Uw geuploadde formaat komt niet geheel overeen met onze aanleverspecificaties. Voor dit product is maatwerk beschikbaar. Wilt maatwerk selecteren in plaats van een hierboven aangegeven formaat? <br>Selecteer hieronder als u verder wilt met een maatwerk formaat."
				: "Uw geuploadde formaat komt niet overeen met onze aanleverspecificaties. Wel kunt u kiezen om verder te gaan met een maatwerk-formaat.<br>Selecteer hieronder om een maatwerk formaat te selecteren.";
		}
	},
	methods: {
		selectFormat (value) {
			this.$store.commit("SET_UPLOADS_COMPLETE", true);
			this.$store.commit("SET_SELECTED_FORMAT", value);
			this.$store.commit("SET_STEP_VALID");
			this.$store.commit("CONFIGURATOR_STEP_AVAILABLE");
		},
		clearFormat () {
			this.$store.commit("CLEAR_SELECTED_FORMAT");
			this.$store.commit("SET_UPLOADS_COMPLETE", false);
			this.$store.commit("SET_STEP_INVALID");
			this.$store.commit("CONFIGURATOR_STEP_AVAILABLE");
		},
		checked (value) {
			return this.selectedFormat !== null
				? this.selectedFormat.id === value
				: false;
		},
		clickHandler () {
			if (!this.checked(this.option.id)) {
				this.selectFormat(this.option.id);
			} else {
				this.clearFormat();
			}
		}
	},
	mounted () {
		if (this.uploaderPosition.before) {
			this.clearFormat();
		}
	}
};
</script>

<style lang="scss">
.custom-size-checkbox {
  display: flex;
  margin-bottom: 15px;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/format/format-custom-choice.vue